<template>
  <div>

    <!-- Tombol kembali -->
    <router-link
      :to="{ name: 'acc-journal-list' }"
      class="text-decoration-none text-white"
    >
      <b-button
        class="mb-1"
        variant="primary"
      >
        <feather-icon
          icon="ArrowLeftIcon"
          class="mr-75"
        />
        Kembali
      </b-button>
    </router-link>

    <b-card>

      <b-button
        variant="success"
        @click="showAddDetailModal = true"
      >
        Tambah Jurnal
      </b-button>
      <b-card class="shadow-sm">
        <b-row>
          <b-col
            md="4"
            class="mb-2"
          >
            <div><small class="text-muted">No Journal</small></div>
            <div class="font-weight-bold">
              {{ journalHeader.trx_no }}
            </div>
          </b-col>
          <b-col
            md="4"
            class="mb-2"
          >
            <div><small class="text-muted">Tanggal</small></div>
            <div class="font-weight-bold">
              {{ journalHeader.date }}
            </div>
          </b-col>
          <b-col
            md="4"
            class="mb-2"
          >
            <div><small class="text-muted">Keterangan</small></div>
            <div class="font-weight-bold">
              {{ journalHeader.desc }}
            </div>
          </b-col>
        </b-row>
      </b-card>

      <!-- Tabel -->
      <vue-good-table
        :columns="columns"
        :rows="rows"
        :pagination-options="{ enabled: false }"
        :fixed-footer="true"
      >
        <template
          slot="table-row"
          slot-scope="props"
        >
          <span v-if="props.column.field === 'no'">
            {{ props.index + 1 }}
          </span>
          <span v-if="props.column.field === 'debit' || props.column.field === 'credit'">
            {{ Number(props.row[props.column.field]).toLocaleString('en-US') }}
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>

          <span
            v-if="props.column.field === 'action'"
          >
            <b-button
              size="sm"
              variant="outline-danger"
              @click="confirmDelete(props.row.id)"
            >
              <feather-icon
                icon="TrashIcon"
                size="16"
              />
            </b-button>
          </span>
        </template>
      </vue-good-table>

      <!-- Modal Edit -->
      <b-modal
        v-model="showEditModal"
        title="Edit Jurnal"
        hide-footer
      >
        <b-form @submit.prevent="saveEdit">
          <b-form-group label="Akun">
            <b-form-input v-model="editData.account_name" />
          </b-form-group>
          <b-form-group label="Debit">
            <b-form-input
              v-model="editData.debit"
              type="number"
            />
          </b-form-group>
          <b-form-group label="Kredit">
            <b-form-input
              v-model="editData.credit"
              type="number"
            />
          </b-form-group>

          <div class="text-right">
            <b-button
              variant="secondary"
              class="mr-2"
              @click="showEditModal = false"
            >
              Batal
            </b-button>
            <b-button
              type="submit"
              variant="primary"
            >
              Simpan
            </b-button>
          </div>
        </b-form>
      </b-modal>
      <b-modal
        v-model="showDeleteModal"
        title="Konfirmasi Hapus"
        hide-footer
      >
        <p>Yakin mau hapus data ini?</p>
        <div class="text-right">
          <b-button
            variant="secondary"
            class="mr-2"
            @click="showDeleteModal = false"
          >
            Batal
          </b-button>
          <b-button
            variant="danger"
            @click="deleteItem"
          >
            Hapus
          </b-button>
        </div>
      </b-modal>
      <b-modal
        v-model="showAddDetailModal"
        title="Tambah Detail Jurnal"
        hide-footer
      >
        <b-form @submit.prevent="saveNewDetail">

          <b-form-group label="COA">
            <v-select
              v-model="newDetail.coa"
              :options="coaOptions"
              label="name"
              :reduce="coa => coa.coa"
              placeholder="Pilih COA"
              :filterable="true"
              :searchable="true"
            />
          </b-form-group>

          <b-form-group label="Debit">
            <b-form-input
              type="text"
              :value="formattedDebit"
              @input="onDebitInput"
            />
            <small
              v-if="errors.debit"
              class="text-danger"
            >
              {{ errors.debit[0] }}
            </small>
          </b-form-group>

          <b-form-group label="Kredit">
            <b-form-input
              type="text"
              :value="formattedCredit"
              @input="onCreditInput"
            />
            <small
              v-if="errors.credit"
              class="text-danger"
            >
              {{ errors.credit[0] }}
            </small>
          </b-form-group>

          <div class="text-right">
            <b-button
              variant="secondary"
              class="mr-2"
              @click="showAddDetailModal = false"
            >
              Batal
            </b-button>
            <b-button
              type="submit"
              variant="primary"
            >
              Simpan
            </b-button>
          </div>
        </b-form>
      </b-modal>
    </b-card>

  </div>
</template>

<script>
import {
  BButton, BCard, BRow, BCol, BModal, BForm, BFormGroup, BFormInput,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import { VueGoodTable } from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'
import vSelect from 'vue-select'

export default {
  components: {
    BButton,
    BCard,
    BRow,
    BCol,
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    VueGoodTable,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      showEditModal: false,
      editData: {},
      showDeleteModal: false, // untuk modal konfirmasi hapus
      uuidToDelete: null, // simpan UUID yang mau dihapus
      journalHeader: {},
      id: this.$route.params.id,
      name: null,
      desc: null,
      required,
      columns: [
        { label: 'No', field: 'no' },
        { label: 'Akun', field: 'account_name' },
        { label: 'Debit', field: 'debit' },
        { label: 'Kredit', field: 'credit' },
        { label: 'Action', field: 'action', tdClass: 'text-center' },
      ],
      rows: [],

      showAddDetailModal: false,
      coaOptions: [], // list COA untuk select
      newDetail: {
        coa: null,
        debit: 0,
        credit: 0,
      },
      errors: {},
    }
  },
  computed: {
    formattedDebit() {
      if (!this.newDetail.debit) return ''
      return this.newDetail.debit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    formattedCredit() {
      if (!this.newDetail.credit) return ''
      return this.newDetail.credit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
  },
  created() {
    this.loadJournal()
    this.$http.get('/coa')
      .then(res => {
        this.coaOptions = res.data.data
      })

    window.addEventListener('resize', this.initTrHeight)
  },
  methods: {
    loadJournal() {
      this.$http.get(`/journal/${this.$route.params.id}`)
        .then(res => {
          this.journalHeader = res.data.data || {}
          this.rows = res.data.details || []
        })
        .catch(err => {
          console.error('Gagal ambil data journal', err)
        })
    },
    openEditModal(row) {
      this.editData = { ...row } // salin semua field dari row ke object baru
      this.showEditModal = true // buka modal
    },
    saveEdit() {
      this.$http.put(`/journal/${this.id}/detail/${this.editData.uuid}`, this.editData)
        .then(() => {
          this.loadJournal() // refresh data
          this.showEditModal = false // tutup modal
        })
        .catch(err => {
          console.error('Gagal simpan perubahan', err)
        })
    },
    confirmDelete(uuid) {
      this.uuidToDelete = uuid
      this.showDeleteModal = true
    },
    deleteItem() {
      console.log('UUID yang dikirim:', this.uuidToDelete)
      if (!this.uuidToDelete) {
        console.warn('UUID kosong, tidak hapus')
        return
      }
      if (!this.uuidToDelete) return

      this.$http.delete(`/journal/deletedetail/${this.uuidToDelete}`)
        .then(() => {
          this.rows = this.rows.filter(r => r.uuid !== this.uuidToDelete)
          this.showDeleteModal = false
          this.uuidToDelete = null
          this.loadJournal() // refresh tabel dari API
        })
        .catch(err => {
          console.error('Gagal hapus data', err)
        })
    },
    openAddDetailModal() {
      this.errors = {}
      this.newDetail = { coa: null, debit: 0, credit: 0 }
      this.showAddDetailModal = true
    },
    onDebitInput(value = '') {
      const plainNumber = value.replace(/,/g, '')
      if (/^\d*$/.test(plainNumber)) {
        this.newDetail.debit = plainNumber
      }
    },
    onCreditInput(value = '') {
      const plainNumber = value.replace(/,/g, '')
      if (/^\d*$/.test(plainNumber)) {
        this.newDetail.credit = plainNumber
      }
    },
    saveNewDetail() {
      const uuid = this.$route.params.id
      this.errors = {}
      if (!this.newDetail.coa) {
        this.errors.coa = ['COA harus dipilih']
      }
      if (this.newDetail.debit <= 0 && this.newDetail.credit <= 0) {
        this.errors.debit = ['Debit atau Kredit harus diisi']
      }

      if (Object.keys(this.errors).length > 0) return

      const payload = {
        id_journal: uuid,
        coa: this.newDetail.coa,
        debit: this.newDetail.debit,
        credit: this.newDetail.credit,
      }

      this.$http.post('/journal/adddetail', payload)
        .then(() => {
          this.loadJournal() // refresh data
          this.showAddDetailModal = false // tutup modal
          this.newDetail = { coa: null, debit: 0, credit: 0 } // reset form
          this.$bvToast.toast('Detail jurnal berhasil ditambahkan!', {
            title: 'Sukses',
            variant: 'success',
            solid: true,
          })
        })
        .catch(err => {
          console.error('Gagal simpan detail', err)
        })
    },
  },
}
</script>
